// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   TextField,
//   IconButton,
//   Typography,
// } from "@mui/material";
// import { Add, Edit, Delete, Save, Cancel } from "@mui/icons-material";

// const Work = () => {
//   // Table data states
//   const [basicInfoData, setBasicInfoData] = useState([]);
//   const [workInfoData, setWorkInfoData] = useState([]);
//   const [workHistoryData, setWorkHistoryData] = useState([]);
//   const [resignationData, setResignationData] = useState([]);

//   // Editing states
//   const [editingBasicInfo, setEditingBasicInfo] = useState(null);
//   const [editingWorkInfo, setEditingWorkInfo] = useState(null);
//   const [editingWorkHistory, setEditingWorkHistory] = useState(null);
//   const [editingResignation, setEditingResignation] = useState(null);

//   // Adding states
//   const [addingBasicInfo, setAddingBasicInfo] = useState(false);
//   const [addingWorkInfo, setAddingWorkInfo] = useState(false);
//   const [addingWorkHistory, setAddingWorkHistory] = useState(false);
//   const [addingResignation, setAddingResignation] = useState(false);

//   // New row states
//   const [newBasicInfo, setNewBasicInfo] = useState({
//     name: "",
//     type: "",
//     department: "",
//     designation: "",
//     from: "",
//     to: "",
//   });
//   const [newWorkInfo, setNewWorkInfo] = useState({
//     department: "",
//     subDepartment: "",
//     designation: "",
//     workLocation: "",
//     categoryControl: "",
//   });
//   const [newWorkHistory, setNewWorkHistory] = useState({
//     subDepartment: "",
//     designation: "",
//     from: "",
//     to: "",
//   });
//   const [newResignation, setNewResignation] = useState({
//     appliedDate: "",
//     status: "",
//     noticePeriod: "",
//     lastWorkingDay: "",
//   });

//   // Common handlers for all tables
//   const handleAdd = (table, newRow, setData, setNewRow, setAdding) => {
//     if (Object.values(newRow).some((val) => !val)) return; // Basic validation
//     setData([{ ...newRow, id: Date.now() }, ...table]);
//     setNewRow(Object.fromEntries(Object.keys(newRow).map((key) => [key, ""])));
//     setAdding(false);
//   };

//   const handleEdit = (id, setEditing) => setEditing(id);
//   const handleCancel = (setEditing) => setEditing(null);
//   const handleCancelAdd = (setAdding, setNewRow, initialValues) => {
//     setAdding(false);
//     setNewRow(initialValues);
//   };
//   const handleDelete = (id, table, setData) =>
//     setData(table.filter((row) => row.id !== id));

//   const handleChange = (id, field, value, table, setData) => {
//     setData(
//       table.map((row) => (row.id === id ? { ...row, [field]: value } : row))
//     );
//   };

//   const handleNewChange = (field, value, newRow, setNewRow) => {
//     setNewRow({ ...newRow, [field]: value });
//   };

//   // Table configurations
//   const tables = [
//     {
//       title: "BASIC INFO",
//       data: basicInfoData,
//       setData: setBasicInfoData,
//       editing: editingBasicInfo,
//       setEditing: setEditingBasicInfo,
//       adding: addingBasicInfo,
//       setAdding: setAddingBasicInfo,
//       newRow: newBasicInfo,
//       setNewRow: setNewBasicInfo,
//       initialNewRow: {
//         name: "",
//         type: "",
//         department: "",
//         designation: "",
//         from: "",
//         to: "",
//       },
//       columns: [
//         { label: "Name", field: "name" },
//         { label: "Type", field: "type" },
//         { label: "Department", field: "department" },
//         { label: "Designation", field: "designation" },
//         { label: "From", field: "from" },
//         { label: "To", field: "to" },
//       ],
//     },
//     {
//       title: "WORK INFO",
//       data: workInfoData,
//       setData: setWorkInfoData,
//       editing: editingWorkInfo,
//       setEditing: setEditingWorkInfo,
//       adding: addingWorkInfo,
//       setAdding: setAddingWorkInfo,
//       newRow: newWorkInfo,
//       setNewRow: setNewWorkInfo,
//       initialNewRow: {
//         department: "",
//         subDepartment: "",
//         designation: "",
//         workLocation: "",
//         categoryControl: "",
//       },
//       columns: [
//         { label: "Department", field: "department" },
//         { label: "Sub Department", field: "subDepartment" },
//         { label: "Designation", field: "designation" },
//         { label: "Work Location", field: "workLocation" },
//         { label: "Category Control", field: "categoryControl" },
//       ],
//     },
//     {
//       title: "WORK HISTORY",
//       data: workHistoryData,
//       setData: setWorkHistoryData,
//       editing: editingWorkHistory,
//       setEditing: setEditingWorkHistory,
//       adding: addingWorkHistory,
//       setAdding: setAddingWorkHistory,
//       newRow: newWorkHistory,
//       setNewRow: setNewWorkHistory,
//       initialNewRow: {
//         subDepartment: "",
//         designation: "",
//         from: "",
//         to: "",
//       },
//       columns: [
//         { label: "Sub Department", field: "subDepartment" },
//         { label: "Designation", field: "designation" },
//         { label: "From", field: "from" },
//         { label: "To", field: "to" },
//       ],
//     },
//     {
//       title: "RESIGNATION",
//       data: resignationData,
//       setData: setResignationData,
//       editing: editingResignation,
//       setEditing: setEditingResignation,
//       adding: addingResignation,
//       setAdding: setAddingResignation,
//       newRow: newResignation,
//       setNewRow: setNewResignation,
//       initialNewRow: {
//         appliedDate: "",
//         status: "",
//         noticePeriod: "",
//         lastWorkingDay: "",
//       },
//       columns: [
//         { label: "Applied Date", field: "appliedDate" },
//         { label: "Status", field: "status" },
//         { label: "Notice Period", field: "noticePeriod" },
//         { label: "Last Working Day", field: "lastWorkingDay" },
//       ],
//     },
//   ];

//   return (
//     <Box
//       sx={{
//         height: "100vh",
//         overflowY: "auto",
//         "&::-webkit-scrollbar": { display: "none" },
//         scrollbarWidth: "none",
//         p: 3,
//         backgroundColor: "white",
//       }}
//     >
//       {tables.map((table, tableIndex) => (
//         <Box key={tableIndex} sx={{ mb: 6 }}>
//           <Typography
//             sx={{
//               fontSize: "12px",
//               mb: 2,
//               pt:1.5,
//               backgroundColor: "#7564e6",
//               color: "white",
//               borderRadius: "20px",
//               display: "inline-block",
//               px: 1,
//               fontWeight: "bold",
//               height:"40px",
//               // width:"100%",
              
//             }}
//           >
//             {table.title}
//           </Typography>

//           <TableContainer
//             component={Paper}
//             sx={{
//               border: "1px solid #ddd",
//               mb: 2,
//             }}
//           >
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ backgroundColor: "#D6E0F5" }}>
//                   {table.columns.map((column) => (
//                     <TableCell
//                       key={column.field}
//                       align="center"
//                       sx={{
//                         fontWeight: "bold",
//                         border: "1px solid #ddd",
//                         py: 1,
//                         fontSize: "0.875rem",
//                       }}
//                     >
//                       {column.label}
//                     </TableCell>
//                   ))}
//                   <TableCell
//                     align="center"
//                     sx={{
//                       fontWeight: "bold",
//                       border: "1px solid #ddd",
//                       py: 1,
//                       fontSize: "0.875rem",
//                     }}
//                   >
//                     <IconButton
//                       color="primary"
//                       onClick={() => table.setAdding(true)}
//                       sx={{
//                         color: "blue",
//                         fontSize:"18px",
//                       }}
//                     >
//                       Add +
//                       {/* <Add /> */}
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {/* Add Row - Only shown when adding */}
//                 {table.adding && (
//                   <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
//                     {table.columns.map((column) => (
//                       <TableCell
//                         key={`new-${column.field}`}
//                         sx={{ border: "1px solid #ddd", py: 1 }}
//                       >
//                         <TextField
//                           fullWidth
//                           size="small"
//                           variant="outlined"
//                           value={table.newRow[column.field]}
//                           onChange={(e) =>
//                             handleNewChange(
//                               column.field,
//                               e.target.value,
//                               table.newRow,
//                               table.setNewRow
//                             )
//                           }
//                           sx={{
//                             "& .MuiOutlinedInput-root": {
//                               borderRadius: "4px",
//                               backgroundColor: "white",
//                             },
//                           }}
//                         />
//                       </TableCell>
//                     ))}
//                     <TableCell
//                       align="center"
//                       sx={{ border: "1px solid #ddd", py: 1 }}
//                     >
//                       <IconButton
//                         color="primary"
//                         onClick={() =>
//                           handleAdd(
//                             table.data,
//                             table.newRow,
//                             table.setData,
//                             table.setNewRow,
//                             table.setAdding
//                           )
//                         }
//                         sx={{
//                           color: "green",
//                           mr: 1,
//                         }}
//                       >
//                         <Save />
//                       </IconButton>
//                       <IconButton
//                         color="secondary"
//                         onClick={() =>
//                           handleCancelAdd(
//                             table.setAdding,
//                             table.setNewRow,
//                             table.initialNewRow
//                           )
//                         }
//                         sx={{
//                           color: "red",
//                         }}
//                       >
//                         <Cancel />
//                       </IconButton>
//                     </TableCell>
//                   </TableRow>
//                 )}

//                 {/* Data Rows */}
//                 {table.data.map((row) => (
//                   <TableRow key={row.id}>
//                     {table.editing === row.id ? (
//                       <>
//                         {table.columns.map((column) => (
//                           <TableCell
//                             key={`edit-${column.field}`}
//                             sx={{ border: "1px solid #ddd", py: 1 }}
//                           >
//                             <TextField
//                               fullWidth
//                               size="small"
//                               variant="outlined"
//                               value={row[column.field]}
//                               onChange={(e) =>
//                                 handleChange(
//                                   row.id,
//                                   column.field,
//                                   e.target.value,
//                                   table.data,
//                                   table.setData
//                                 )
//                               }
//                               sx={{
//                                 "& .MuiOutlinedInput-root": {
//                                   borderRadius: "4px",
//                                   backgroundColor: "white",
//                                 },
//                               }}
//                             />
//                           </TableCell>
//                         ))}
//                         <TableCell
//                           align="center"
//                           sx={{ border: "1px solid #ddd", py: 1 }}
//                         >
//                           <IconButton
//                             color="primary"
//                             onClick={() => table.setEditing(null)}
//                             sx={{
//                               color: "green",
//                               mr: 1,
//                             }}
//                           >
//                             <Save />
//                           </IconButton>
//                           <IconButton
//                             color="secondary"
//                             onClick={() => handleCancel(table.setEditing)}
//                             sx={{
//                               color: "red",
//                             }}
//                           >
//                             <Cancel />
//                           </IconButton>
//                         </TableCell>
//                       </>
//                     ) : (
//                       <>
//                         {table.columns.map((column) => (
//                           <TableCell
//                             key={`view-${column.field}`}
//                             align="center"
//                             sx={{ border: "1px solid #ddd", py: 1 }}
//                           >
//                             {row[column.field]}
//                           </TableCell>
//                         ))}
//                         <TableCell
//                           align="center"
//                           sx={{ border: "1px solid #ddd", py: 1 }}
//                         >
//                           <IconButton
//                             color="primary"
//                             onClick={() => handleEdit(row.id, table.setEditing)}
//                             sx={{
//                               color: "orange",
//                               mr: 1,
//                             }}
//                           >
//                             <Edit />
//                           </IconButton>
//                           <IconButton
//                             color="error"
//                             onClick={() =>
//                               handleDelete(row.id, table.data, table.setData)
//                             }
//                             sx={{
//                               color: "red",
//                             }}
//                           >
//                             <Delete />
//                           </IconButton>
//                         </TableCell>
//                       </>
//                     )}
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Box>
//       ))}
//       <br></br>
//       <br></br>
//       <br></br>
//       <br></br>
//       <br></br>
//       <br></br>
//       {/* Action Buttons */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           gap: 3,
//           mt: 4,
//           pt: 2,
//           borderTop: "1px solid #eee",
//         }}
//       >
//         {["Back", "Submit", "Cancel", "Next"].map((action, index) => (
//           <Button
//             key={action}
//             variant="contained"
//             sx={{
//               borderRadius: "20px",
//               fontWeight: "bold",
//               textTransform: "none",
//               px: 4,
//               py: 1,
//               backgroundColor:
//                 action === "Back"
//                   ? "#DC7C7D"
//                   : action === "Submit"
//                   ? "#29BF2E"
//                   : action === "Cancel"
//                   ? "#f44336"
//                   : "#7B4E86",
//               "&:hover": {
//                 backgroundColor:
//                   action === "Back"
//                     ? "#DC7C7D"
//                     : action === "Submit"
//                     ? "#29BF2E"
//                     : action === "Cancel"
//                     ? "#d32f2f"
//                     : "#7B4E86",
//               },
//             }}
//           >
//             {action}
//           </Button>
//         ))}
//       </Box>
//     </Box>
//   );
// };

// export default Work;



import React, { useState } from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Typography,
  Grid,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  useTheme,
  Tabs,
  Tab,
  AppBar,
  Toolbar
} from "@mui/material";
import {
  Add,
  Edit,
  Delete,
  Save,
  Cancel,
  Close,
  Visibility,
  ArrowBack,
  CheckCircle,
  Cancel as CancelIcon,
  NavigateNext
} from "@mui/icons-material";

const Work = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  
  // Tab state for mobile
  const [mobileTab, setMobileTab] = useState(0);
  
  // Table data states
  const [basicInfoData, setBasicInfoData] = useState([]);
  const [workInfoData, setWorkInfoData] = useState([]);
  const [workHistoryData, setWorkHistoryData] = useState([]);
  const [resignationData, setResignationData] = useState([]);

  // Editing states
  const [editingBasicInfo, setEditingBasicInfo] = useState(null);
  const [editingWorkInfo, setEditingWorkInfo] = useState(null);
  const [editingWorkHistory, setEditingWorkHistory] = useState(null);
  const [editingResignation, setEditingResignation] = useState(null);

  // Adding states
  const [addingBasicInfo, setAddingBasicInfo] = useState(false);
  const [addingWorkInfo, setAddingWorkInfo] = useState(false);
  const [addingWorkHistory, setAddingWorkHistory] = useState(false);
  const [addingResignation, setAddingResignation] = useState(false);

  // View dialog state
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [viewingRow, setViewingRow] = useState(null);
  const [viewingSection, setViewingSection] = useState("");

  // New row states
  const [newBasicInfo, setNewBasicInfo] = useState({
    name: "",
    type: "",
    department: "",
    designation: "",
    from: "",
    to: "",
  });
  const [newWorkInfo, setNewWorkInfo] = useState({
    department: "",
    subDepartment: "",
    designation: "",
    workLocation: "",
    categoryControl: "",
  });
  const [newWorkHistory, setNewWorkHistory] = useState({
    subDepartment: "",
    designation: "",
    from: "",
    to: "",
  });
  const [newResignation, setNewResignation] = useState({
    appliedDate: "",
    status: "",
    noticePeriod: "",
    lastWorkingDay: "",
  });

  // Sample data for demo
  React.useEffect(() => {
    // Demo data
    setBasicInfoData([
      {
        id: 1,
        name: "John Doe",
        type: "Permanent",
        department: "IT",
        designation: "Software Engineer",
        from: "2023-01-15",
        to: "Present",
      },
      {
        id: 2,
        name: "Jane Smith",
        type: "Contract",
        department: "HR",
        designation: "HR Manager",
        from: "2022-06-01",
        to: "Present",
      },
    ]);
    
    setWorkInfoData([
      {
        id: 1,
        department: "IT",
        subDepartment: "Development",
        designation: "Senior Developer",
        workLocation: "New York",
        categoryControl: "A1",
      },
    ]);
    
    setWorkHistoryData([
      {
        id: 1,
        subDepartment: "Development",
        designation: "Junior Developer",
        from: "2020-01-01",
        to: "2022-12-31",
      },
    ]);
    
    setResignationData([
      {
        id: 1,
        appliedDate: "2024-01-15",
        status: "Pending",
        noticePeriod: "30 days",
        lastWorkingDay: "2024-02-15",
      },
    ]);
  }, []);

  // Common handlers for all tables
  const handleAdd = (table, newRow, setData, setNewRow, setAdding) => {
    if (Object.values(newRow).some((val) => !val)) {
      alert("Please fill all fields!");
      return;
    }
    setData([{ ...newRow, id: Date.now() }, ...table]);
    setNewRow(Object.fromEntries(Object.keys(newRow).map((key) => [key, ""])));
    setAdding(false);
  };

  const handleEdit = (id, setEditing) => setEditing(id);
  const handleCancel = (setEditing) => setEditing(null);
  const handleCancelAdd = (setAdding, setNewRow, initialValues) => {
    setAdding(false);
    setNewRow(initialValues);
  };
  
  const handleDelete = (id, table, setData) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      setData(table.filter((row) => row.id !== id));
    }
  };

  const handleChange = (id, field, value, table, setData) => {
    setData(
      table.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const handleNewChange = (field, value, newRow, setNewRow) => {
    setNewRow({ ...newRow, [field]: value });
  };

  const handleView = (row, section) => {
    setViewingRow(row);
    setViewingSection(section);
    setViewDialogOpen(true);
  };

  // Table configurations
  const tables = [
    {
      id: "basic",
      title: "BASIC INFO",
      data: basicInfoData,
      setData: setBasicInfoData,
      editing: editingBasicInfo,
      setEditing: setEditingBasicInfo,
      adding: addingBasicInfo,
      setAdding: setAddingBasicInfo,
      newRow: newBasicInfo,
      setNewRow: setNewBasicInfo,
      initialNewRow: {
        name: "",
        type: "",
        department: "",
        designation: "",
        from: "",
        to: "",
      },
      columns: [
        { label: "Name", field: "name" },
        { label: "Type", field: "type" },
        { label: "Department", field: "department" },
        { label: "Designation", field: "designation" },
        { label: "From", field: "from" },
        { label: "To", field: "to" },
      ],
      mobileTitle: "Basic Info",
      icon: <CheckCircle />,
    },
    {
      id: "work",
      title: "WORK INFO",
      data: workInfoData,
      setData: setWorkInfoData,
      editing: editingWorkInfo,
      setEditing: setEditingWorkInfo,
      adding: addingWorkInfo,
      setAdding: setAddingWorkInfo,
      newRow: newWorkInfo,
      setNewRow: setNewWorkInfo,
      initialNewRow: {
        department: "",
        subDepartment: "",
        designation: "",
        workLocation: "",
        categoryControl: "",
      },
      columns: [
        { label: "Department", field: "department" },
        { label: "Sub Department", field: "subDepartment" },
        { label: "Designation", field: "designation" },
        { label: "Work Location", field: "workLocation" },
        { label: "Category Control", field: "categoryControl" },
      ],
      mobileTitle: "Work Info",
      icon: <CheckCircle />,
    },
    {
      id: "history",
      title: "WORK HISTORY",
      data: workHistoryData,
      setData: setWorkHistoryData,
      editing: editingWorkHistory,
      setEditing: setEditingWorkHistory,
      adding: addingWorkHistory,
      setAdding: setAddingWorkHistory,
      newRow: newWorkHistory,
      setNewRow: setNewWorkHistory,
      initialNewRow: {
        subDepartment: "",
        designation: "",
        from: "",
        to: "",
      },
      columns: [
        { label: "Sub Department", field: "subDepartment" },
        { label: "Designation", field: "designation" },
        { label: "From", field: "from" },
        { label: "To", field: "to" },
      ],
      mobileTitle: "History",
      icon: <CheckCircle />,
    },
    {
      id: "resignation",
      title: "RESIGNATION",
      data: resignationData,
      setData: setResignationData,
      editing: editingResignation,
      setEditing: setEditingResignation,
      adding: addingResignation,
      setAdding: setAddingResignation,
      newRow: newResignation,
      setNewRow: setNewResignation,
      initialNewRow: {
        appliedDate: "",
        status: "",
        noticePeriod: "",
        lastWorkingDay: "",
      },
      columns: [
        { label: "Applied Date", field: "appliedDate" },
        { label: "Status", field: "status" },
        { label: "Notice Period", field: "noticePeriod" },
        { label: "Last Working Day", field: "lastWorkingDay" },
      ],
      mobileTitle: "Resignation",
      icon: <CheckCircle />,
    },
  ];

  // Mobile View with Tabs (No Sidebar)
  const renderMobileView = () => {
    const currentTable = tables[mobileTab];
    
    return (
      <Box sx={{ 
        height: "100vh", 
        overflow: "hidden",
        backgroundColor: "#f5f5f5",
        scrollbarWidth:'none',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Header with Title */}
        <Box sx={{ 
          backgroundColor: "#7564e6", 
          color: "white",
          py: 2,
          px: 2,
          textAlign: 'center'
        }}>
          <Typography variant="h6" fontWeight="bold">
            Work Details
          </Typography>
        </Box>

        {/* Tabs for Mobile Navigation */}
        <Box sx={{ 
          backgroundColor: "white",
          borderBottom: 1,
          borderColor: 'divider',
          position: 'sticky',
          top: 0,
          zIndex: 10
        }}>
          <Tabs
            value={mobileTab}
            onChange={(e, newValue) => setMobileTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              '& .MuiTab-root': {
                minWidth: 'auto',
                fontSize: '0.75rem',
                padding: '8px 12px'
              }
            }}
          >
            {tables.map((table, index) => (
              <Tab 
                key={table.id} 
                label={table.mobileTitle}
                icon={table.icon}
                iconPosition="start"
              />
            ))}
          </Tabs>
        </Box>

        {/* Main Content */}
        <Box sx={{ 
          flex: 1,
          overflowY: "auto",
          p: 2
        }}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ color: "#7564e6", mb: 2 }}>
              {currentTable.title}
            </Typography>
            
            {/* Add Button */}
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => currentTable.setAdding(true)}
              sx={{
                mb: 2,
                backgroundColor: "#7564e6",
                borderRadius: "20px",
                "&:hover": {
                  backgroundColor: "#1c3d82",
                },
              }}
              fullWidth
            >
              Add New Record
            </Button>

            {/* Add Form */}
            {currentTable.adding && (
              <Card sx={{ mb: 2, backgroundColor: "#f0f7ff", border: "1px solid #7564e6" }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ color: "#7564e6", fontWeight: 'bold' }}>
                      Add New Record
                    </Typography>
                    <IconButton 
                      size="small" 
                      onClick={() => handleCancelAdd(currentTable.setAdding, currentTable.setNewRow, currentTable.initialNewRow)}
                    >
                      <Close fontSize="small" />
                    </IconButton>
                  </Box>
                  <Grid container spacing={1}>
                    {currentTable.columns.map((column) => (
                      <Grid item xs={12} key={`new-mobile-${column.field}`}>
                        <TextField
                          fullWidth
                          size="small"
                          label={column.label}
                          value={currentTable.newRow[column.field]}
                          onChange={(e) =>
                            handleNewChange(
                              column.field,
                              e.target.value,
                              currentTable.newRow,
                              currentTable.setNewRow
                            )
                          }
                          sx={{ mb: 1 }}
                        />
                      </Grid>
                    ))}
                    <Grid item xs={12}>
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
                        <Button
                          size="small"
                          variant="contained"
                          startIcon={<Save />}
                          onClick={() =>
                            handleAdd(
                              currentTable.data,
                              currentTable.newRow,
                              currentTable.setData,
                              currentTable.setNewRow,
                              currentTable.setAdding
                            )
                          }
                        >
                          Save
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<CancelIcon />}
                          onClick={() =>
                            handleCancelAdd(
                              currentTable.setAdding,
                              currentTable.setNewRow,
                              currentTable.initialNewRow
                            )
                          }
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}

            {/* Data Cards */}
            {currentTable.data.map((row) => (
              <Card key={row.id} sx={{ 
                mb: 2, 
                border: "1px solid #e0e0e0",
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}>
                <CardContent>
                  {currentTable.editing === row.id ? (
                    // Edit Mode
                    <Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="subtitle2" sx={{ color: "#ff9800", fontWeight: 'bold' }}>
                          Editing Record
                        </Typography>
                        <IconButton 
                          size="small" 
                          onClick={() => handleCancel(currentTable.setEditing)}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      </Box>
                      <Grid container spacing={1}>
                        {currentTable.columns.map((column) => (
                          <Grid item xs={12} key={`edit-mobile-${column.field}`}>
                            <TextField
                              fullWidth
                              size="small"
                              label={column.label}
                              value={row[column.field]}
                              onChange={(e) =>
                                handleChange(
                                  row.id,
                                  column.field,
                                  e.target.value,
                                  currentTable.data,
                                  currentTable.setData
                                )
                              }
                              sx={{ mb: 1 }}
                            />
                          </Grid>
                        ))}
                        <Grid item xs={12}>
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
                            <Button
                              size="small"
                              variant="contained"
                              startIcon={<Save />}
                              onClick={() => currentTable.setEditing(null)}
                            >
                              Save Changes
                            </Button>
                            <Button
                              size="small"
                              variant="outlined"
                              startIcon={<CancelIcon />}
                              onClick={() => handleCancel(currentTable.setEditing)}
                            >
                              Cancel
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  ) : (
                    // View Mode
                    <Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                        <Box>
                          <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#7564e6" }}>
                            {row[currentTable.columns[0].field]}
                          </Typography>
                          {currentTable.columns.length > 1 && (
                            <Typography variant="body2" color="text.secondary">
                              {row[currentTable.columns[1].field]}
                            </Typography>
                          )}
                        </Box>
                        <Box>
                          <IconButton 
                            size="small" 
                            onClick={() => handleView(row, currentTable.title)}
                            sx={{ color: "#7564e6" }}
                          >
                            <Visibility fontSize="small" />
                          </IconButton>
                          <IconButton 
                            size="small" 
                            onClick={() => handleEdit(row.id, currentTable.setEditing)}
                            sx={{ color: "#ff9800" }}
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                          <IconButton 
                            size="small" 
                            onClick={() => handleDelete(row.id, currentTable.data, currentTable.setData)}
                            sx={{ color: "#f44336" }}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </Box>
                      </Box>
                      
                      <Grid container spacing={1} sx={{ mt: 1 }}>
                        {currentTable.columns.slice(2).map((column, idx) => (
                          <Grid item xs={6} key={`view-mobile-${column.field}`}>
                            <Typography variant="caption" color="text.secondary" display="block">
                              {column.label}:
                            </Typography>
                            <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                              {row[column.field] || "-"}
                            </Typography>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  )}
                </CardContent>
              </Card>
            ))}

            {currentTable.data.length === 0 && !currentTable.adding && (
              <Box sx={{ 
                textAlign: 'center', 
                py: 4,
                backgroundColor: 'white',
                borderRadius: 2,
                border: '1px dashed #ddd'
              }}>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                  No records found
                </Typography>
                <Button
                  variant="outlined"
                  startIcon={<Add />}
                  onClick={() => currentTable.setAdding(true)}
                  size="small"
                >
                  Add First Record
                </Button>
              </Box>
            )}
          </Box>
        </Box>

        {/* Bottom Action Buttons for Mobile */}
        
      </Box>
    );
  };

  // Desktop/Tablet View
  const renderDesktopView = () => {
    return (
      <Box
        sx={{
          height: "100vh",
          overflowY: "auto",
          scrollbarWidth:'none',
          "&::-webkit-scrollbar": { width: 8 },
          "&::-webkit-scrollbar-track": { backgroundColor: "#f1f1f1" },
          "&::-webkit-scrollbar-thumb": { backgroundColor: "#888", borderRadius: 4 },
          "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
          p: { xs: 2, sm: 3 },
          backgroundColor: "white",
        }}
      >
        {tables.map((table, tableIndex) => (
          <Box key={tableIndex} sx={{ mb: 6 }}>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              mb: 2 
            }}>
              <Typography
                sx={{
                  fontSize: { xs: "11px", sm: "12px" },
                  pt: 1.5,
                  backgroundColor: "#7564e6",
                  color: "white",
                  borderRadius: "20px",
                  display: "inline-block",
                  px: 2,
                  py: 0.5,
                  fontWeight: "bold",
                  height: "36px",
                  minWidth: { xs: "100px", sm: "120px" },
                  textAlign: "center",
                }}
              >
                {table.title}
              </Typography>
              
              <Button
                variant="contained"
                size="small"
                startIcon={<Add />}
                onClick={() => table.setAdding(true)}
                sx={{
                  backgroundColor: "#7564e6",
                  borderRadius: "16px",
                  fontSize: { xs: "0.7rem", sm: "0.8rem" },
                  px: 2,
                  py: 0.5,
                  "&:hover": {
                    backgroundColor: "#1c3d82",
                  },
                }}
              >
                Add New
              </Button>
            </Box>

            <TableContainer
              component={Paper}
              sx={{
                border: "1px solid #ddd",
                mb: 2,
                overflowX: "auto",
              }}
            >
              <Table sx={{ minWidth: isTablet ? 800 : "auto" }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#D6E0F5" }}>
                    {table.columns.map((column) => (
                      <TableCell
                        key={column.field}
                        align="center"
                        sx={{
                          fontWeight: "bold",
                          border: "1px solid #ddd",
                          py: 1,
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                          whiteSpace: "nowrap",
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                    <TableCell
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        border: "1px solid #ddd",
                        py: 1,
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Add Row - Only shown when adding */}
                  {table.adding && (
                    <TableRow sx={{ backgroundColor: "#f0f7ff" }}>
                      {table.columns.map((column) => (
                        <TableCell
                          key={`new-${column.field}`}
                          sx={{ border: "1px solid #ddd", py: 1 }}
                        >
                          <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            value={table.newRow[column.field]}
                            onChange={(e) =>
                              handleNewChange(
                                column.field,
                                e.target.value,
                                table.newRow,
                                table.setNewRow
                              )
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "4px",
                                backgroundColor: "white",
                              },
                            }}
                          />
                        </TableCell>
                      ))}
                      <TableCell
                        align="center"
                        sx={{ border: "1px solid #ddd", py: 1 }}
                      >
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                          <Button
                            variant="contained"
                            size="small"
                            startIcon={<Save />}
                            onClick={() =>
                              handleAdd(
                                table.data,
                                table.newRow,
                                table.setData,
                                table.setNewRow,
                                table.setAdding
                              )
                            }
                            sx={{
                              backgroundColor: "#29BF2E",
                              "&:hover": { backgroundColor: "#1e8e25" }
                            }}
                          >
                            Save
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<Cancel />}
                            onClick={() =>
                              handleCancelAdd(
                                table.setAdding,
                                table.setNewRow,
                                table.initialNewRow
                              )
                            }
                            sx={{
                              borderColor: "#f44336",
                              color: "#f44336",
                              "&:hover": { borderColor: "#d32f2f" }
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}

                  {/* Data Rows */}
                  {table.data.map((row) => (
                    <TableRow key={row.id} hover>
                      {table.editing === row.id ? (
                        <>
                          {table.columns.map((column) => (
                            <TableCell
                              key={`edit-${column.field}`}
                              sx={{ border: "1px solid #ddd", py: 1 }}
                            >
                              <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                value={row[column.field]}
                                onChange={(e) =>
                                  handleChange(
                                    row.id,
                                    column.field,
                                    e.target.value,
                                    table.data,
                                    table.setData
                                  )
                                }
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "4px",
                                    backgroundColor: "white",
                                  },
                                }}
                              />
                            </TableCell>
                          ))}
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid #ddd", py: 1 }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<Save />}
                                onClick={() => table.setEditing(null)}
                                sx={{
                                  backgroundColor: "#29BF2E",
                                  "&:hover": { backgroundColor: "#1e8e25" }
                                }}
                              >
                                Save
                              </Button>
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<Cancel />}
                                onClick={() => handleCancel(table.setEditing)}
                                sx={{
                                  borderColor: "#f44336",
                                  color: "#f44336",
                                  "&:hover": { borderColor: "#d32f2f" }
                                }}
                              >
                                Cancel
                              </Button>
                            </Box>
                          </TableCell>
                        </>
                      ) : (
                        <>
                          {table.columns.map((column) => (
                            <TableCell
                              key={`view-${column.field}`}
                              align="center"
                              sx={{ 
                                border: "1px solid #ddd", 
                                py: 1,
                                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                maxWidth: "200px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                              }}
                              title={row[column.field]}
                            >
                              {row[column.field] || "-"}
                            </TableCell>
                          ))}
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid #ddd", py: 1 }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<Visibility />}
                                onClick={() => handleView(row, table.title)}
                                sx={{
                                  borderColor: "#7564e6",
                                  color: "#7564e6",
                                  "&:hover": { borderColor: "#0d47a1" }
                                }}
                              >
                                View
                              </Button>
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<Edit />}
                                onClick={() => handleEdit(row.id, table.setEditing)}
                                sx={{
                                  borderColor: "#ff9800",
                                  color: "#ff9800",
                                  "&:hover": { borderColor: "#f57c00" }
                                }}
                              >
                                Edit
                              </Button>
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<Delete />}
                                onClick={() =>
                                  handleDelete(row.id, table.data, table.setData)
                                }
                                sx={{
                                  borderColor: "#f44336",
                                  color: "#f44336",
                                  "&:hover": { borderColor: "#d32f2f" }
                                }}
                              >
                                Delete
                              </Button>
                            </Box>
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  ))}

                  {table.data.length === 0 && !table.adding && (
                    <TableRow>
                      <TableCell 
                        colSpan={table.columns.length + 1}
                        align="center"
                        sx={{ py: 4, color: "text.secondary" }}
                      >
                        <Typography variant="body1" sx={{ mb: 1 }}>
                          No records found
                        </Typography>
                        <Button
                          variant="outlined"
                          startIcon={<Add />}
                          onClick={() => table.setAdding(true)}
                          size="small"
                        >
                          Add First Record
                        </Button>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ))}

        {/* Action Buttons */}
        {/*  */}
      </Box>
    );
  };

  // View Details Dialog
  const renderViewDialog = () => {
    if (!viewingRow) return null;
    
    const currentTable = tables.find(t => t.title === viewingSection) || tables[0];
    
    return (
      <Dialog 
        open={viewDialogOpen} 
        onClose={() => setViewDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          backgroundColor: "#7564e6", 
          color: "white",
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="h6">
            {viewingSection} Details
          </Typography>
          <IconButton onClick={() => setViewDialogOpen(false)} sx={{ color: "white" }}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Grid container spacing={2}>
            {currentTable.columns.map((column) => (
              <Grid item xs={12} key={`dialog-${column.field}`}>
                <Typography variant="subtitle2" color="text.secondary">
                  {column.label}
                </Typography>
                <Typography variant="body1" sx={{ 
                  mt: 0.5,
                  p: 1,
                  backgroundColor: '#f5f5f5',
                  borderRadius: 1
                }}>
                  {viewingRow[column.field] || "N/A"}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button 
            onClick={() => setViewDialogOpen(false)}
            variant="contained"
            sx={{ 
              borderRadius: "20px",
              backgroundColor: "#7564e6",
              "&:hover": { backgroundColor: "#1c3d82" }
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <>
      {isMobile ? renderMobileView() : renderDesktopView()}
      {renderViewDialog()}
    </>
  );
};

export default Work;